import { POSTFORM, POST, GET } from '@/utils/request.ts'

// 考试结果提交
export const submitExamResult = (params: object) => {
  return POST({
    url: '/v3/exam/postQustionsResult',
    data: params,
    showError: false
  })
}
// 查询考试题
export const getExamList = (params: object) => {
  return GET({
    url: '/v3/exam/queryQuestionsByCourierId',
    params,
    showError: false
  })
}
// 获取闪送员考试次数
export const examNumber = (params: object) => {
  return GET({
    url: '/v3/exam/queryCountByCourierId',
    params,
    showError: false
  })
}
// 查询闪送员招募状态信息
export const statusInfo = (params: object) => {
  return GET({
    url: '/courier/api/h5/v2/recruits/queryCourierRecruit',
    params,
    showError: false
  })
}
// 完成招募在线学习课程
export const finishOnlineLearn = (params: object) => {
  return POST({
    url: '/v3/recruit/finishOnlineLearn',
    params,
    showError: false
  })
}
// 课程活陪许下线时上报后台
export const courseOffline = (params: object) => {
  return POST({
    url: '/v3/recruit/courseOffline',
    data: params,
    showError: false
  })
}
// 取消预约
export const cancelAppointment = (params: object) => {
  return POST({
    url: '/v3/recruit/cancelAppointment',
    params,
    showError: false
  })
}
// 重新预约
export const appointmentAgain = (params: object) => {
  return POST({ url: '/v3/recruit/appointmentAgain', params, showError: false })
}
// 线上招募 重新认证
export const onlineAgain = (params: object) => {
  return GET({ url: '/v3/recruit/online/auth/again', params, showError: false })
}
// 线下申请审核不通过原因
export const applyNoPassReason = (params: object) => {
  return GET({ url: '/v3/recruit/auditReason', params, showError: false })
}
// 线上申请审核不通过原因
export const applyNoPassOnlineReason = (params: object) => {
  return GET({ url: '/v3/recruit/approve/fail/reason', params, showError: false })
}
// 提交评价师评价
export const rateCityManager = (params) => {
  return POST({ url: '/v3/recruit/rateCityManager', params, showError: false })
}
// 查询闪送员在线培训信息
export const queryOnlineLearnInfo = (params: object) => {
  return GET({
    url: '/v3/recruit/queryOnlineLearnInfo',
    params,
    showError: false
  })
}
// 查询城市站点
export const trainCityAddressList = (params: object) => {
  return GET({
    url: '/v3/recruit/trainAddressList',
    params: params,
    showError: false
  })
}
// 查询闪送员培训站点信息
export const getTrainInfo = (params: object) => {
  return GET({
    url: '/v3/rainAddresses/recruits/getTrainInfo',
    params: params,
    showError: false
  })
}
// 获取闪送员供应商信息
export const getSupplierInfo = (params: object) => {
  return GET({
    url: '/v3/courier/detailInfo',
    params: params,
    showError: false
  })
}
// 预约成功文案
export const appointmentSuccess = (params: object) => {
  return POST({
    url: '/v3/recruit/appointmentSuccess',
    params: params,
    showError: false
  })
}
// 闪送员端通过H5查询闪送员招募状态
export const getCourierRecruit = (params: object) => {
  return GET({
    url: '/courier/api/h5/v2/recruits/queryCourierRecruit',
    params: params,
    showError: false
  })
}
// 简单获取闪送员招募状态信息
export const getCourierMsg = (params: object) => {
  return GET({
    url: '/v3/courier/courierMsg',
    params: params,
    showError: false
  })
}
// 查询培训场次
export const getSiteDuty = (params: object) => {
  return GET({
    url: '/v3/rainAddresses/querySiteDuty',
    params: params,
    showError: false
  })
}
// 查询闪送员信息
export const getCourierDetail = (params: object) => {
  return GET({
    url: '/courier/api/h5/v2/stock/queryCourierDetail',
    params: params,
    showError: false
  })
}
// 确认场次 申请转城 重新预约确认场次
export const submitSiteDuty = (params: object) => {
  return POST({ url: params.url, params: params, showError: false })
}
// 查询闪送员注销状态
export const checkLogoff = (params: object) => {
  return GET({
    url: '/v3/account/cancellation/status',
    params: params,
    showError: false
  })
}
